import TabletProgressBar from './TabletProgressBar'
export default TabletProgressBar
